// @ts-strict-ignore
import {isProduction} from 'common/report/util';
import {UploadBuckets} from 'common/widgets/upload-media/types';

/*
Happens to match MediaCardType in Dashboards. Dashboards just needs to have a mapping for media types supported there.
*/
export enum UserMediaType {
  Image = `image`,
  Video = `video`,
  EmbeddedImage = `embed_image`,
  EmbeddedVideo = `embed_video`,
}

export enum LexiconEntityType {
  Events = `events`,
}

export const LEXICON_ENTITY_TO_FOLDER_MAPPING = {
  [LexiconEntityType.Events]: `events`,
};

const BUCKET_TO_IMAGE_SRC_MAPPING: {[key in UploadBuckets]: string} = {
  [UploadBuckets.Dashboard]: `user-media/dashboards`,
  [UploadBuckets.Lexicon]: `user-media/lexicon`,
};

export function getUploadFolderPath(bucket: UploadBuckets, entityType: string) {
  let folderPath = null;
  if (bucket === UploadBuckets.Lexicon && entityType) {
    folderPath = LEXICON_ENTITY_TO_FOLDER_MAPPING[entityType];
  }
  return folderPath;
}

export function getImageSrcUrlBasedOnStorageBucket(path: string, bucket: UploadBuckets, folderPath: string = null) {
  const bucketImageSrc = BUCKET_TO_IMAGE_SRC_MAPPING[bucket];
  const imageSrc = folderPath ? `${bucketImageSrc}/${folderPath}` : bucketImageSrc;
  if (isProduction()) {
    return `https://cdn.mxpnl.com/${imageSrc}/${path}`;
  }
  return `https://cdn-dev.mxpnl.com/${imageSrc}/${path}`;
}
